import {
  APP_INITIALIZER,
  ModuleWithProviders,
  NgModule,
  Optional,
  SkipSelf,
} from '@angular/core';
import { CommonModule, registerLocaleData } from '@angular/common';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import vi from '@angular/common/locales/vi';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { NZ_I18N, vi_VN } from 'ng-zorro-antd/i18n';

import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  AuthConfig,
  OAuthModule,
  OAuthModuleConfig,
  OAuthStorage,
} from 'angular-oauth2-oidc';
import { ShouldLoginComponent } from './components/should-login/should-login.component';
import {
  authAppInitializerFactory,
  endpointsInitializerFactory,
} from './auth/auth-app-initializer.factory';
import { AuthService } from './auth/auth.service';
import { AppConfigService } from './config/config.service';
import { NzMessageModule } from 'ng-zorro-antd/message';
import { NZ_CONFIG, NzConfig } from 'ng-zorro-antd/core/config';
import { StatesModule } from './states/states.module';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { icons } from './icons';
//import { authCodeFlowConfig } from 'src/environments/auth/auth-config';
import { MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { UiFormModule } from './ui-form/ui-form.module';
import { CookieService } from 'ngx-cookie-service';
import { JWT_OPTIONS, JwtHelperService } from '@auth0/angular-jwt';
import { MatSelectModule } from '@angular/material/select';

registerLocaleData(vi);
export function storageFactory(): OAuthStorage {
  return localStorage;
}

const ngZorroConfig: NzConfig = {
  message: {
    nzMaxStack: 1,
    nzDuration: 3000,
  },
};

// ✅ NEW: build AuthConfig từ runtime config.json
export function authConfigFactory(config: AppConfigService): AuthConfig {
  const raw = (config.getConfig() as any)?.DefaultAuthConfig ?? {};

  return {
    ...raw,
    // bắt buộc đảm bảo redirectUri đúng theo domain đang chạy (prod/stg/local)
    redirectUri: window.location.origin,
    // fallback an toàn nếu config.json thiếu (giữ hành vi cũ)
    responseType: raw.responseType ?? 'code',
    oidc: raw.oidc ?? false,
    scope: raw.scope ?? 'openid profile email offline_access',
    clearHashAfterLogin: raw.clearHashAfterLogin ?? false,
  } as AuthConfig;
}




const customCurrencyMaskConfig = {
  align: 'left',
  thousands: '.',
  prefix: '',
  decimal: ',',
  precision: 0,
  allowNegative: false,
};
@NgModule({
  declarations: [NotFoundComponent, ShouldLoginComponent],
  imports: [
    NzIconModule.forRoot(icons),
    CommonModule,
    BrowserModule,
    StatesModule,
    UiFormModule,
    MatNativeDateModule,
    HttpClientModule,
    NzModalModule,
    MatSelectModule,
    OAuthModule.forRoot(),
    BrowserAnimationsModule,
    NzMessageModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  providers: [
    { provide: NZ_I18N, useValue: vi_VN },
    { provide: NZ_CONFIG, useValue: ngZorroConfig },
    { provide: MAT_DATE_LOCALE, useValue: 'vi-VN' },
    { provide: JWT_OPTIONS, useValue: JWT_OPTIONS },
    // { provide: CURRENCY_MASK_CONFIG, useValue: customCurrencyMaskConfig },
    JwtHelperService,
  ],
})
export class CoreModule {
  static forRoot(): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: [
        CookieService,
        {
          provide: APP_INITIALIZER,
          useFactory: authAppInitializerFactory,
          deps: [AuthService],
          multi: true,
        },
        
        // ✅ CHANGED: AuthConfig lấy từ AppConfigService (runtime)
        {
          provide: AuthConfig,
          useFactory: authConfigFactory,
          deps: [AppConfigService],
        },


        {
          provide: OAuthModuleConfig,
          useFactory: endpointsInitializerFactory,
          deps: [AppConfigService],
        },
        { provide: OAuthStorage, useFactory: storageFactory },
      ],
    };
  }
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error(
        'CoreModule is already loaded. Import it in the AppModule only'
      );
    }
  }
}
export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http);
}
